import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
declare let gtag: Function;
declare let fbq:Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(  private router:Router,){


    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', 'AW-397434627',
        {
          'page_path': event.urlAfterRedirects
        }
       );

          fbq('track', 'PageView');
       }});

  }
  title = 'landing';
}
